/**
 * @generated SignedSource<<3ad115ba5da45d648c7ff3036bdbd6a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgAdminCreateTeamSelectTeamsQuery$variables = {
  topicId?: string | null;
};
export type OrgAdminCreateTeamSelectTeamsQuery$data = {
  readonly organisation: {
    readonly id: string;
    readonly rootWorkspace: {
      readonly potentialReceiverStores: ReadonlyArray<{
        readonly store: {
          readonly id: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"ReceiverStoresSelector_receiverStores">;
      }>;
    };
    readonly topics: ReadonlyArray<{
      readonly id: string;
      readonly isPrivate: boolean;
      readonly " $fragmentSpreads": FragmentRefs<"TopicSelector_orgTopic">;
    }> | null;
  };
};
export type OrgAdminCreateTeamSelectTeamsQuery = {
  response: OrgAdminCreateTeamSelectTeamsQuery$data;
  variables: OrgAdminCreateTeamSelectTeamsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "topicId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "topicId",
    "variableName": "topicId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgAdminCreateTeamSelectTeamsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Organisation",
          "kind": "LinkedField",
          "name": "organisation",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Workspace",
              "kind": "LinkedField",
              "name": "rootWorkspace",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": (v2/*: any*/),
                  "concreteType": "ReceiverStore",
                  "kind": "LinkedField",
                  "name": "potentialReceiverStores",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Store",
                      "kind": "LinkedField",
                      "name": "store",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ReceiverStoresSelector_receiverStores"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "OrgTopic",
              "kind": "LinkedField",
              "name": "topics",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                (v3/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TopicSelector_orgTopic"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrgAdminCreateTeamSelectTeamsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "rootWorkspace",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "ReceiverStore",
                "kind": "LinkedField",
                "name": "potentialReceiverStores",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "store",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "includeExternalId",
                            "value": true
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "workspaceBreadcrumbs",
                        "storageKey": "workspaceBreadcrumbs(includeExternalId:true)"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "routedTeams",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "icon",
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OrgTopic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d3970918423eb215dcc03be81d99671a",
    "id": null,
    "metadata": {},
    "name": "OrgAdminCreateTeamSelectTeamsQuery",
    "operationKind": "query",
    "text": "query OrgAdminCreateTeamSelectTeamsQuery(\n  $topicId: ID\n) {\n  organisation {\n    id\n    rootWorkspace {\n      potentialReceiverStores(topicId: $topicId) {\n        store {\n          id\n        }\n        ...ReceiverStoresSelector_receiverStores\n        id\n      }\n      id\n    }\n    topics {\n      id\n      isPrivate\n      ...TopicSelector_orgTopic\n    }\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment AHTeamIconCircle on Team {\n  color\n  ...AHTeamIcon\n  isPrivate\n}\n\nfragment OrgStoreWorkspaceBreadcrumbs_store on Store {\n  workspaceBreadcrumbs(includeExternalId: true)\n}\n\nfragment ReceiverStoresSelectorListItem_receiverStore on ReceiverStore {\n  store {\n    ...ReceiverStoresSelectorMain_receiverStore\n    id\n  }\n  routedTeams {\n    ...ReceiverStoresSelectorTeamsIndicator_teams\n    id\n  }\n}\n\nfragment ReceiverStoresSelectorMain_receiverStore on Store {\n  id\n  name\n  ...OrgStoreWorkspaceBreadcrumbs_store\n}\n\nfragment ReceiverStoresSelectorTeamsIndicator_teams on Team {\n  id\n  name\n  ...AHTeamIconCircle\n}\n\nfragment ReceiverStoresSelector_receiverStores on ReceiverStore {\n  store {\n    id\n    name\n    workspaceBreadcrumbs(includeExternalId: true)\n  }\n  ...ReceiverStoresSelectorListItem_receiverStore\n}\n\nfragment TopicSelector_orgTopic on OrgTopic {\n  id\n  name\n  isPrivate\n}\n"
  }
};
})();

(node as any).hash = "013e07c82eb8b4ff1f8defd4da86d681";

export default node;
